import React from "react";
import { View } from "react-native";
import { useDispatch } from "react-redux";
import { Text } from "../../Text";
import { ModifyOptionsAsyncAction, OptionChoice } from "@/app/types/option";
import { modifyOptionsAsync } from "@/app/actions/options";
import { Dispatch } from "redux";
import { TouchableOpacity } from "../../Buttons";
import { getCheckboxOptions } from "@/app/utils/options";
import Checkbox from "../../Checkbox";
import { itemCheckboxStyles } from "./styles";

type ItemCheckboxProps = {
  lineItemId: number;
  optionId: number;
  optionTitle: string;
  choices: OptionChoice[];
};

const ItemCheckbox = ({
  lineItemId,
  optionId,
  choices,
  optionTitle,
}: ItemCheckboxProps): JSX.Element => {
  const dispatch = useDispatch<Dispatch<ModifyOptionsAsyncAction>>();
  const onChoicePress = (choiceId: number) => {
    dispatch(modifyOptionsAsync({ lineId: lineItemId, optionId, choiceId }));
  };

  const { alternateChoice, enabled } = getCheckboxOptions(choices);

  const styles = itemCheckboxStyles(enabled);

  return (
    <TouchableOpacity
      onPress={() => onChoicePress(alternateChoice.id)}
      style={styles.checkboxContainer}
    >
      <View style={styles.container}>
        <Checkbox enabled={enabled} />
        <Text style={styles.optionText}>{optionTitle}</Text>
      </View>
    </TouchableOpacity>
  );
};

export default ItemCheckbox;
